/** How long before context JWT `exp` we proactively refresh (access cookie + select-context). */
export const PROACTIVE_CONTEXT_REFRESH_BEFORE_SEC = 2 * 60

/** Poll interval for expiry hook — not every second (avoids unnecessary work). */
export const CONTEXT_TOKEN_EXPIRY_CHECK_INTERVAL_MS = 30_000

/** Activity listener: at most one near-expiry check per this window. */
export const ACTIVITY_REFRESH_THROTTLE_MS = 60_000
